<header>
  <div class="container-lg header-container">
    <!-- Left  -->
    <div class="header-container-left">
      <button *ngIf="sidebar?.mobileSidebarActive" type="button" class="scg-unstyled-button hamburger-button" (click)="sidebar?.showMobileSidebar()"><fa-icon [icon]="['fas', 'bars']"></fa-icon></button>
      <div class="logo-container">
        <a *ngIf="(auth.role === UserRole.Default || auth.role === UserRole.Parents) && !isActiveRouteDeviceNotFound(); else logoWithoutLink" routerLink="/dashboard" [ngClass]="{ 'scg-logo-shrink': auth.isLoggedIn }" class="scg-logo"></a>
        <ng-template #logoWithoutLink>
          <div [ngClass]="{ 'scg-logo-shrink': auth.isLoggedIn }" class="scg-logo"></div>
        </ng-template>
        <!-- <a [routerLink]="(auth.role === UserRole.Default || auth.role === UserRole.Parents) ? ['/dashboard'] : null" [ngClass]="{ 'scg-logo-shrink': auth.isLoggedIn }" class="scg-logo"></a> -->
      </div>
    </div>
    <!-- Right -->


    <div class="header-container-right">

      <!-- Header/Kebab menu -->
      <button
        *ngIf="auth.isLoggedIn && (auth.role === UserRole.Default || auth.role === UserRole.Parents) && !isActiveRouteDeviceNotFound()"
        appMenuTrigger
        [menuTriggerFor]="kebabMenu"
        type="button"
        class="scg-header-button scg-kebab-button scg-unstyled-button"
      >
        <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
      </button>


      <app-menu #kebabMenu>
        <a *ngIf="!environment.production" app-menu-item [routerLink]="['/readonly-report']">Dev: ReadOnly-Report</a>
        <a app-menu-item (click)="gaLog('Header-ParentsApp')" [routerLink]="['/parents']">{{'PARENTS.APP'|translate}}</a>
        <a app-menu-item (click)="gaLog('Header-Manual')" [href]="'URL.MANUAL' | translate" target="_blank">{{'MENU_SMALL.MANUAL'|translate}}</a>
        <a app-menu-item (click)="gaLog('Header-NotificationOverview')"  [routerLink]="['/notification-overview']">{{'NOTIFY.NOTICE_ALL'|translate}}</a>
        <a app-menu-item (click)="gaLog('Header-WhatsNew')"  [routerLink]="['/whatsnew']">{{'MISC.WHATSNEW'|translate}}</a>
        <a app-menu-item (click)="gaLog('Header-Feedback')"  [routerLink]="['/feedback']">{{'FEEDBACK.TITLE'|translate}}</a>
        <a app-menu-item (click)="gaLog('Header-PortalLog')"  [routerLink]="['/portallog']">{{'PORTALLOG.TITLE'|translate}}</a>
        <a app-menu-item (click)="showProfileModal()">{{'PROFILES.TITLE'|translate}}</a>
        <a app-menu-item (click)="gaLog('Header-MyData')" routerLink="/mydata">{{'MYDATA.TITLE'|translate}} / {{'MYDATA.LICENCES'|translate}}</a>
        <app-menu-divider></app-menu-divider>
        <button app-menu-item type="button" (click)="onLogoutClick()">{{'MENU_SMALL.LOGOUT'|translate}}</button>
      </app-menu>

      <app-device-dropdown *ngIf="auth.isLoggedIn && (auth.role === UserRole.Default || auth.role === UserRole.Parents) && !isActiveRouteDeviceNotFound()" class="scg-device-dropdown"></app-device-dropdown>

      <!-- Report role -->
      <ng-container *ngIf="auth.isLoggedIn && auth.role === UserRole.Report">
        <div *ngIf="showBackButton()" [ngSwitch]="auth.role">
          <a *ngSwitchCase="UserRole.Report" [routerLink]="['/readonly-report']" class="btn btn-primary mr-3" >{{'BUTTON.BACK'|translate}}</a>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- ReadOnly notice for report view -->
  <ng-container *ngIf="auth.isLoggedIn && auth.role === UserRole.Report">
    <div class="need-sync-notice scg-bg-midgrey scg-white text-center">
      {{'MISC.READ_ONLY_HEADER'|translate}}
       <button type="button" (click)="showReadOnlyMsg()" class="scg-unstyled-button scg-link-hidden text-white pl-1">({{'COMMON.INFO'|translate}})</button>
    </div>
  </ng-container>

  <!-- Sync notice -->
  <ng-container *ngIf="auth.isLoggedIn  && auth.role !== UserRole.Report">
    <div *ngIf="showNeedSync" class="need-sync-notice scg-bg-blue scg-white text-center">
      {{'MESSAGE.NEED_SYNC'|translate}}
      <a [routerLink]="['/sync']" class="scg-link-hidden text-white text pl-1">({{'COMMON.INFO'|translate}})</a>
    </div>
    <div *ngIf="showNeedSyncDone" class="need-sync-notice scg-bg-midgrey scg-white text-center">
      {{'MESSAGE.SYNC_DONE'|translate}}
    </div>
  </ng-container>
</header>

<div class="header-placeholder"></div>
<div *ngIf="(showNeedSync || showNeedSyncDone) && auth.isLoggedIn  && auth.role !== UserRole.Report" class="need-sync-notice-placeholder"></div>
<div *ngIf="auth.role === UserRole.Report" class="need-sync-notice-placeholder"></div>
